import Http from "@/config/axios.js"
import {to} from "await-to-js"

export default {
    async current() {
        return to(Http.get(window.API_PREFIX + "/domain"))
    },
}

